import { mapActions } from 'vuex'
import { dateToShow, dateToMysql } from '@/helpers/dates'

// import { isEmpty } from 'lodash'
import { success } from '@/utils/alert'

const prepareSave = profile => {
  if (profile.birthdate === 'Invalid date') {
    profile.birthdate = '1900-01-01'
  } else {
    profile.birthdate = dateToMysql(profile.birthdate)
  }

  if (profile.state === null) {
    delete profile.state
  }

  return profile
}

const prepareShow = profile => {
  profile.birthdate = dateToShow(profile.birthdate)

  return profile
}

export default {
  ...mapActions(['updateUserData', 'logout', 'userIsProfessional', 'userIsCompany']),
  doSave () {
    this.$v.$touch()
    this.$nextTick(() => this.focusFirstStatus())

    if (this.$v.$error) {
      return
    }

    const profile = prepareSave({...this.profile})

    this.$resource.update('me', profile)
      .then(({data}) => {
        const user = {...data}
        user.avatar = user.avatar + '?' + new Date()
        this.updateUserData(user)
        this.show = true

        success('Seu dados foram alterados com sucesso.')
      })
      .catch(({data}) => {
        this.errors = data
      })
  },
  doLoad () {
    this.$resource.get('/me')
      .then(({data}) => {
        this.profile = prepareShow({...data})
      })
  },
  onUploadedAvatar (response) {
    if (!response) {
      return
    }
    const user = {...response}
    user.image = user.image + '?' + new Date()
    this.updateUserData(user)
  },
  doToggleModal (value) {
    this.showModal = value
  },
  focusFirstStatus (component = this) {
    if (component.status) {
      component.$el.focus()
      return true
    }

    let focused = false

    component.$children.some((childComponent) => {
      focused = this.focusFirstStatus(childComponent)
      return focused
    })

    return focused
  },

  doLogout () {
    const isProfessional = (user) => {
      return user.type === 'professional'
    }
    const isCompany = (user) => {
      return user.type === 'company'
    }
    this.logout()
      .then(() => {
        if (isProfessional(this.user)) {
          return this.$router.push({name: 'auth.professional.login'})
        }

        if (isCompany(this.user)) {
          return this.$router.push({name: 'auth.company.login'})
        }

        window.location.href = '/'
      })
  },
  getPassword (password) {
    this.showModalPassword = true
    this.isPassword = true
  },
  closePassword () {
    this.isPassword = false
    this.showModalPassword = false
  }
}



// WEBPACK FOOTER //
// ./src/app/settings/profile/resources/methods.js